module.exports = __webpack_public_path__ + "static/media/helios-rifle.6b239759.jpg";